module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<app-sidebar></app-sidebar>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main